// @flow
import React, { Component } from 'react';
import moment from 'moment';
import { Label } from '../../Typography.jsx';
// import { Link } from 'react-router-dom';
// import { Error } from './Typography.jsx';
// import styles from '../styles/PatientCard.scss';
import ContentBox from '../../ContentBox.jsx';

import type { Note } from '../../../util/aggregatedNotesUtil';

type Props = {
  note: Note,
}

class NotesCard extends Component<Props> {
  render() {
    const { note } = this.props;
    const dateAsText = note.lastEditDate ? moment(note.lastEditDate).format('DD-MM-YYYY') : 'N/A';
    return (
      <ContentBox key={note._id}>
        <Label>Context: </Label>
        { note.mainText }
        <br />
        <Label>Notes: </Label>
        { note.notes }
        <br />
        <br />
        Last edited by{' '}
        <b>{ note.lastEditor }</b> on <b>{ dateAsText }</b>
      </ContentBox>
    );
  }
}

export default NotesCard;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/aggregatedNotes/NotesCard.jsx